<template>
    <div class="control-panel">
        <slot name="left">
            <div class="control-panel__title">
                    <h2 class="header2">
                        <slot>
                            {{ title }}
                        </slot>
                    </h2>
                    <v-breadcrumbs v-if="breadcrumbs" class="path" :items="breadcrumbs" :divider="breadcrumbsDivider">
                        <template v-slot:item="{ item }">
                            <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                                {{ item.text }}
                            </v-breadcrumbs-item>
                        </template>
                    </v-breadcrumbs>
            </div>
        </slot>

        <slot name="right">
            <div class="action-wrapper">
                <slot name="actions"></slot>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: "ControlPanel",

    data() {
        return {};
    },

    props: {
        breadcrumbs: {
            type: Array,
            default: null,
        },

        breadcrumbsDivider: {
            type: String,
            default: '/',
        },

        title: {
            type: String,
            default: "",
        },
    },
};
</script>
